import infoBtn from "assets/images/info_btn.svg";
import { ReactComponent as WarningIcon } from "assets/symbols/warning.svg";
import AccountAuditWindow from "components/Audit/AccountAuditWindow";
import Alert from "components/General/Alert";
import Status from "components/General/Status";
import SvgBtn from "components/General/SvgBtn";
import ModalComponent from "components/Modal/ModalComponent";
import { fetchHandleDeleteAccount } from "helpers/Account/AccountHelpers";
import { highlightMatchInString } from "helpers/GeneralHelpers";
import { ReactNode, useState } from "react";
import { Button } from "react-bootstrap";
import Moment from "react-moment";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const AccountEntryComponent = ({
  account,
  accessToken,
  editAccountUrl,
  searchValue,
}) => {
  //#region constants
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [displayModal, setDisplayModal] = useState(false);
  const [modalAction, setModalAction] = useState("");
  const [modalTitle, setModalTitle] = useState("");
  const [modalBody, setModalBody] = useState<string | ReactNode>("");
  const [showAudit, setShowAudit] = useState(false);
  //#endregion

  //#region functions
  const onRemoveClicked = () => {
    setModalAction("Delete");
    setModalTitle("Delete Account");
    setModalBody(
      <div className="text-label-3 gap-4 flex flex-col">
        <span>
          Are you sure you want to delete the selected account? This action
          cannot be undone.
        </span>
        <Alert icon={<WarningIcon />} variant="warning">
          This action cannot be undone.
        </Alert>
      </div>
    );
    setDisplayModal(true);
  };

  const handleDeleteConfirmed = () => {
    dispatch(fetchHandleDeleteAccount(accessToken, account.accountId));
    setDisplayModal(false);
  };

  const handleClose = () => {
    setDisplayModal(false);
  };
  //#endregion
  return (
    <>
      <tr>
        <td>
          <div className="column_flex">
            <span className="label_bold">
              {highlightMatchInString(
                searchValue,
                `${account.firstName} ${account.lastName}`
              )}
            </span>

            <label>{highlightMatchInString(searchValue, account.email)}</label>
          </div>
        </td>
        <td>{account.organisation?.organisationName}</td>
        <td>
          <Status archived={account.archived} suspended={account.suspended} />
        </td>
        <td>{account.licence.licenceName}</td>
        <td>
          <Moment format="DD/MM/YYYY">{account.licence.nextInvoiceDate}</Moment>
        </td>
        <td className="text-end">
          <div className="flex flex-row items-center justify-end gap-4">
            <SvgBtn
              color="black"
              icon={infoBtn}
              onClick={() => setShowAudit(true)}
            />
            <Button variant="link-2" onClick={() => navigate(editAccountUrl)}>
              Edit
            </Button>
            <Button
              variant="link-2"
              disabled={account.archived}
              onClick={onRemoveClicked}
            >
              Remove
            </Button>
          </div>
        </td>
      </tr>
      <ModalComponent
        actionHandler={handleDeleteConfirmed}
        handleClose={handleClose}
        displayModal={displayModal}
        action={modalAction}
        modalTitle={modalTitle}
        modalBody={modalBody}
        size={450}
      />
      <AccountAuditWindow
        account={account}
        show={showAudit}
        handleClose={() => setShowAudit(false)}
      ></AccountAuditWindow>
    </>
  );
};

export default AccountEntryComponent;
